import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import FeaturedWork from './components/FeaturedWork';
import ArticlesPreview from './components/ArticlesPreview';
import StatsSection from './components/StatsSection';
import CTASection from './components/CTASection';
import SchemaOrg from '@/components/feature/SchemaOrg';
import SEOMeta from '@/components/feature/SEOMeta';

export default function HomePage() {
  const origin = typeof window !== 'undefined' ? window.location.origin : '';

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '黄瓜传媒',
    alternateName: 'Cucumber Media',
    url: origin,
    logo: `${origin}/vite.svg`,
    description: '黄瓜传媒是专注于品牌内容创作、数字营销与媒体传播的专业平台。',
    address: {
      '@type': 'PostalAddress',
      addressLocality: '北京市',
      addressRegion: '朝阳区',
      streetAddress: '建国路88号SOHO现代城A座2208室',
      addressCountry: 'CN',
    },
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '400-888-6666',
      contactType: '客户服务',
      availableLanguage: 'Chinese',
    },
    sameAs: [
      'https://weibo.com',
      'https://www.douyin.com',
      'https://www.xiaohongshu.com',
    ],
  };

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '黄瓜传媒',
    url: origin,
    potentialAction: {
      '@type': 'SearchAction',
      target: `${origin}/search?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  };

  const webpageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '黄瓜传媒 - 专业内容创作与品牌传播平台',
    description: '黄瓜传媒是专注于品牌内容创作、数字营销与媒体传播的专业平台。',
    url: origin,
    isPartOf: {
      '@type': 'WebSite',
      name: '黄瓜传媒',
      url: origin,
    },
    about: {
      '@type': 'Organization',
      name: '黄瓜传媒',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '黄瓜传媒提供哪些服务？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '黄瓜传媒提供品牌策划、视频制作、社交媒体运营、数字营销和创意设计等一站式品牌传播解决方案。',
        },
      },
      {
        '@type': 'Question',
        name: '如何与黄瓜传媒合作？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以通过官网预约咨询，或拨打400-888-6666与我们联系，我们将根据您的需求提供定制化方案。',
        },
      },
      {
        '@type': 'Question',
        name: '黄瓜传媒服务过哪些行业？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '黄瓜传媒服务覆盖快消、美妆、餐饮、教育、科技、制造等多个行业，累计服务超过200个品牌。',
        },
      },
    ],
  };

  return (
    <>
      <SEOMeta
        title="黄瓜传媒 - 专业内容创作与品牌传播平台"
        description="黄瓜传媒是专注于品牌内容创作、数字营销与媒体传播的专业平台。为企业提供创意策划、视频制作、社交媒体运营等一站式传播解决方案。"
        keywords="黄瓜传媒,黄瓜传媒内容创作,黄瓜传媒品牌传播,黄瓜传媒数字营销,黄瓜传媒视频制作,黄瓜传媒社交媒体,黄瓜传媒营销解决方案"
        canonical={origin}
      />
      <SchemaOrg schema={organizationSchema} />
      <SchemaOrg schema={websiteSchema} />
      <SchemaOrg schema={webpageSchema} />
      <SchemaOrg schema={faqSchema} />
      <HeroSection />
      <ServicesSection />
      <FeaturedWork />
      <ArticlesPreview />
      <StatsSection />
      <CTASection />
    </>
  );
}